import { useTranslation } from "react-i18next";
import { Add, People } from "iconsax-react";
import { Button } from "@/shared/ui";

interface Props {
  onAddClick?: () => void;
  showAddButton?: boolean;
  onManagersClick?: () => void;
}

export default function EmployeesHeader({ onAddClick, showAddButton, onManagersClick }: Props) {
  const { t } = useTranslation("EmployeesPage");

  return (
    <div className="flex items-center justify-between gap-3 pt-1 pb-4 border-b surface-base-stroke mb-5 pr-1">
      <h1 className="text-display-xs content-base-primary">{t("header.title")}</h1>

      <div className="flex items-center gap-2">
        {onManagersClick && (
          <Button variant="secondary" size="lg" className="h-9" onClick={onManagersClick}>
            <People size={16} color="currentColor" />
            {t("managers.open")}
          </Button>
        )}
        {showAddButton && onAddClick && (
          <Button variant="primary" size="lg" className="h-9" onClick={onAddClick}>
            <Add size={16} color="currentColor" />
            {t("header.addWorker")}
          </Button>
        )}
      </div>
    </div>
  );
}
